import {defineSlotRecipe} from '@chakra-ui/react3'

const productAnimatedModuleRecipe = defineSlotRecipe({
    slots: ['container', 'textBox', 'productBox', 'textContent'],
    base: {
        container: {
            display: 'flex',
            alignItems: 'center',
            alignContent: 'center',
            h: 'auto',
            align: 'start',
            px: {base: 0, s: 'spacing-90'},
            pb: {base: 0, s: 'spacing-128'}
        },
        textBox: {
            boxSizing: 'border-box',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center'
        },
        textContent: {
            display: 'flex',
            flexDirection: 'column',
            gap: 'spacing-16',
            width: '100%'
        },
        productBox: {
            height: {base: 300, s: '100%'}
        }
    },
    variants: {
        layout: {
            'side-by-side': {
                container: {
                    flexDirection: {base: 'column', s: 'row'},
                    px: '0',
                    pb: '0'
                },
                textBox: {
                    w: {base: '100%', s: '50%'},
                    alignItems: 'flex-start',
                    pt: {base: 'spacing-64', s: 'spacing-90'},
                    pr: {base: 'spacing-24', s: 'spacing-90'},
                    pb: {base: 'spacing-48', s: 'spacing-90'},
                    pl: {base: 'spacing-24', s: 'spacing-90'}
                },
                textContent: {
                    maxWidth: {base: 'auto', s: 409},
                    textAlign: 'left'
                },
                productBox: {
                    w: {base: '100%', s: '50%'}
                }
            },
            'product-below-copy': {
                container: {
                    flexDirection: 'column'
                },
                textBox: {
                    w: '100%',
                    alignItems: 'center',
                    pt: {base: 'spacing-64', s: 'spacing-128'},
                    pr: {base: 'spacing-24', s: '0'},
                    pb: {base: 'spacing-48', s: 'spacing-40'},
                    pl: {base: 'spacing-24', s: '0'}
                },
                textContent: {
                    maxWidth: {base: 'auto', s: 622},
                    textAlign: {base: 'left', s: 'center'}
                },
                productBox: {
                    w: '100%'
                }
            }
        }
    }
})

export default productAnimatedModuleRecipe
